function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-63.478 -60.256)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(98.357 101.246)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M164.44,163.061v-9.729h3.013a4.023,4.023,0,0,1,3.018,1.173,4.163,4.163,0,0,1,1.142,3.03v1.33a4.15,4.15,0,0,1-1.142,3.031,4.033,4.033,0,0,1-3.018,1.166Zm1.3-8.693v7.664h1.717a2.625,2.625,0,0,0,2.1-.889,3.369,3.369,0,0,0,.765-2.279v-1.342a3.349,3.349,0,0,0-.765-2.266,2.625,2.625,0,0,0-2.1-.888Z",
  transform: "translate(-164.44 -153.192)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M217.775,158.551h-3.934v3.482h4.607v1.029h-5.9v-9.729h5.83v1.037h-4.535v3.147h3.934Z",
  transform: "translate(-191.288 -153.192)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M264.066,163.061h-1.3l-4.612-7.43-.04.013v7.417h-1.3v-9.729h1.3l4.613,7.425.038-.014v-7.411h1.3Z",
  transform: "translate(-215.999 -153.192)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M310.906,154.369h-3.158v8.693h-1.3v-8.693h-3.119v-1.037h7.575Z",
  transform: "translate(-241.957 -153.192)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M356.991,159.772l.013.04a2.943,2.943,0,0,1-.947,2.292,3.59,3.59,0,0,1-2.573.922,3.362,3.362,0,0,1-2.65-1.17,4.347,4.347,0,0,1-1.022-2.967v-1.731a4.358,4.358,0,0,1,1.022-2.97,3.356,3.356,0,0,1,2.65-1.173,3.682,3.682,0,0,1,2.585.879,2.929,2.929,0,0,1,.935,2.328l-.013.04h-1.245a2.188,2.188,0,0,0-.591-1.617,2.254,2.254,0,0,0-1.671-.595,2.034,2.034,0,0,0-1.732.889,3.661,3.661,0,0,0-.645,2.2v1.745a3.685,3.685,0,0,0,.645,2.218,2.033,2.033,0,0,0,1.732.889,2.263,2.263,0,0,0,1.671-.592,2.2,2.2,0,0,0,.591-1.634Z",
  transform: "translate(-267.898 -153.016)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M404.195,158.89a4.186,4.186,0,0,1-1.09,2.96,3.672,3.672,0,0,1-2.825,1.176,3.487,3.487,0,0,1-2.729-1.176,4.281,4.281,0,0,1-1.05-2.96v-1.731a4.3,4.3,0,0,1,1.05-2.96,3.476,3.476,0,0,1,2.729-1.183,3.666,3.666,0,0,1,2.825,1.18,4.2,4.2,0,0,1,1.09,2.963Zm-1.3-1.745a3.314,3.314,0,0,0-.711-2.192,2.351,2.351,0,0,0-1.907-.855,2.185,2.185,0,0,0-1.807.855,3.43,3.43,0,0,0-.674,2.192v1.745a3.452,3.452,0,0,0,.674,2.205,2.183,2.183,0,0,0,1.807.855,2.36,2.36,0,0,0,1.912-.852,3.347,3.347,0,0,0,.706-2.208Z",
  transform: "translate(-293.956 -153.016)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M450.924,158.758h-4.041v4.3h-1.3v-9.729h6.008v1.037h-4.711v3.354h4.041Z",
  transform: "translate(-321.351 -153.192)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(63.478 60.256)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(37.547 0)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 23.644,
  height: 7.099,
  transform: "translate(0 12.479)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  width: 25.235,
  height: 7.419,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  width: 25.415,
  height: 7.419,
  transform: "translate(0 24.638)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("path", {
  d: "M89.868,60.256,82.86,80.007,75.535,60.256H63.478v32.46h8.343l-.174-20.85,7.782,20.85H85.6l8.019-20.9-.174,20.9h8.67V60.256Z",
  transform: "translate(-63.478 -60.256)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M221.807,60.256V67.6h9.337V92.716h8.807V67.6h9.336V60.256Z",
  transform: "translate(-158.939 -60.256)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M296.417,60.256h-8.289L274.157,92.139l-.254.577H283.5l2.427-6.211H298.16l2.566,6.211H310.5Zm-.773,19.3h-7.112l3.6-9.295Z",
  transform: "translate(-190.819 -60.256)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M369.779,85.235V60.256h-8.853v32.46h21.644V85.235Z",
  transform: "translate(-242.424 -60.256)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M435.453,60.256h-8.289L413.193,92.139l-.254.577h9.594L424.96,86.5H437.2l2.566,6.211h9.773Zm-.773,19.3h-7.112l3.6-9.295Z",
  transform: "translate(-277.987 -60.256)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M525.986,80.122a7.643,7.643,0,0,0-1.53-2.314,8.034,8.034,0,0,0-2.264-1.625,9.574,9.574,0,0,0-1.537-.592,8.466,8.466,0,0,0,2.952-2.164,6.834,6.834,0,0,0,1.6-4.627,7.541,7.541,0,0,0-1.095-4.2,8.019,8.019,0,0,0-2.8-2.614,12.428,12.428,0,0,0-3.766-1.341,21.678,21.678,0,0,0-4-.387H499.963v32.46H513.54a23.37,23.37,0,0,0,4.729-.478,13.209,13.209,0,0,0,4.166-1.592,8.3,8.3,0,0,0,4.121-7.547A7.523,7.523,0,0,0,525.986,80.122Zm-9.851,4.931a5.9,5.9,0,0,1-1.7.521,12.162,12.162,0,0,1-1.873.152H508.49V79.311h4.023a9.02,9.02,0,0,1,3.926.717,2.372,2.372,0,0,1,1.31,2.357,2.867,2.867,0,0,1-.438,1.663A3.005,3.005,0,0,1,516.135,85.053Zm-.521-12.993a5.616,5.616,0,0,1-3.242.8H508.49v-5.7H512a7.473,7.473,0,0,1,3.6.683,2.1,2.1,0,0,1,1.076,1.989A2.531,2.531,0,0,1,515.614,72.061Z",
  transform: "translate(-326.556 -60.256)",
  fill: "#fff"
})));

var SvgMetalab = function SvgMetalab(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 51,
    viewBox: "0 0 200 51",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMetalab, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/metalab.bea35296.svg";
export { ForwardRef as ReactComponent };